import { render, staticRenderFns } from "./doctorOrder.vue?vue&type=template&id=0afb7662&scoped=true&"
import script from "./doctorOrder.vue?vue&type=script&lang=js&"
export * from "./doctorOrder.vue?vue&type=script&lang=js&"
import style0 from "./doctorOrder.vue?vue&type=style&index=0&id=0afb7662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb7662",
  null
  
)

export default component.exports